import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { onUnmounted, ref, getCurrentInstance } from "vue";
import { ElMessage } from "element-plus";
export default /*#__PURE__*/_defineComponent({
  props: {
    mail: {
      type: String,
      default: ""
    }
  },
  setup: function setup(__props) {
    var props = __props;

    var _getCurrentInstance = getCurrentInstance(),
        proxy = _getCurrentInstance.proxy;

    var disabled = ref(false);
    var loading = ref(false);
    var text = ref("发送验证码");
    var interval;

    var send = function send() {
      proxy.$axios.post("/api/sendVerificationCode", {
        mail: props.mail
      }).then(function (res) {
        loading.value = false;
        ElMessage({
          message: "验证码发送成功!",
          type: "success"
        });
        var countDown = 60;
        interval = setInterval(function () {
          text.value = "\u8BF7\u7B49\u5F85".concat(countDown, "\u79D2");
          countDown--;

          if (countDown <= 0) {
            disabled.value = false;
            text.value = "\u53D1\u9001\u9A8C\u8BC1\u7801";
            clearInterval(interval);
          }
        }, 1000);
      }).catch(function () {
        loading.value = false;
        disabled.value = false;
      });
    };

    var sendCode = function sendCode() {
      if (!props.mail) {
        ElMessage.error("请输入正确的邮箱!");
        return;
      }

      loading.value = true;
      disabled.value = true;
      send();
    };

    onUnmounted(function () {
      clearInterval(interval);
    });
    return function (_ctx, _cache) {
      var _component_el_button = _resolveComponent("el-button");

      return _openBlock(), _createBlock(_component_el_button, {
        type: "primary",
        loading: loading.value,
        disabled: disabled.value,
        onClick: _cache[0] || (_cache[0] = function ($event) {
          return sendCode();
        })
      }, {
        default: _withCtx(function () {
          return [_createTextVNode(_toDisplayString(text.value), 1)];
        }),
        _: 1
      }, 8, ["loading", "disabled"]);
    };
  }
});